export const FETCHING_EVENT_DETAILS_TEXT = "Fetching event details.";
export const FETCH_EVENT_DETAILS_ERROR_TEXT = "Error while fetching event details !";
export const SUBSCRIBER_API_URL = "/api-gateway/apis/name/Event-Subscriber";
export const REQUEST_FOR_AUTH_URL = "/events/user-guide#section/Subscribe-to-Events/Request-for-Authorization";
export const NEO_TEAM_DETAILS_URL = "/teams";
